<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">TOMA DE LECTURA</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <!-- {{ data }} -->
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div v-if="getTakeRead.length > 0" class="ctn_take_read">
                      <div class="take_read_colum">
                        <div class="copy_read_colum">
                          <h2>ULTIMA LECTURA</h2>
                          <p class="day">
                            <span
                              class="lbs sw_active"
                              v-if="data.switch == true"
                              >{{
                                data.switch == true ? "Encendido" : "Apagado"
                              }}</span
                            >
                            <span class="lbs sw_inactive" v-else>{{
                              data.switch == true ? "Encendido" : "Apagado"
                            }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="take_read_colum">
                        <div class="copy_read_colum">
                          <h3>
                            {{ getTakeRead.usage }}
                          </h3>
                          <p>{{ getTakeRead.dateNow | formatDateFrom }}</p>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <!-- {{ getTakeRead }} -->
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="nui"
                      v-model="data.nui"
                      :rules="nameRules"
                      label="NUI"
                      required
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="idx"
                      v-model="data.idx"
                      label="IDX"
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="profile"
                      v-model="data.profile"
                      :items="['post', 'pre']"
                      label="Perfil"
                      :rules="fieldRules"
                      disabled
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item == "post" ? "Postpago" : "Prepago" }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        {{ item == "post" ? "Postpago" : "Prepago" }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="subTypeService"
                      v-model="data.subTypeService"
                      :items="['Agua', 'Gas', 'Energia']"
                      label="Tipo"
                      :rules="fieldRules"
                      disabled
                    >
                    </v-select>
                  </v-col>
                  <v-col
                    class="colm_custom"
                    cols="6"
                    sm="12"
                    md="6"
                  >
                    <v-menu
                      v-model="datePicker1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          ref="date-init"
                          v-model="dateIni"
                          label="Fecha Inicial"
                          prepend-icon="mdi-calendar"
                          :rules="nameRules"
                          :disabled="isMassive"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="date-init"
                        v-model="dateIni"
                        :max="new Date().toISOString().substr(0, 10)"
                        @input="datePicker1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    class="colm_custom"
                    cols="6"
                    sm="12"
                    md="6"
                  >
                    <v-menu
                      v-model="datePicker2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          ref="date-dateEnd"
                          v-model="dateEnd"
                          label="Fecha Final"
                          prepend-icon="mdi-calendar"
                          :rules="nameRules"
                          :disabled="isMassive"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="date-dateEnd"
                        v-model="dateEnd"
                        :min="new Date(dateIni).toISOString().substr(0, 10)"
                        :max="new Date().toISOString().substr(0, 10)"
                        @input="datePicker2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" sm="12" md="6">
                    <v-autocomplete
                      ref="period"
                      v-model="form.period"
                      :items="periodSelect"
                      :search-input.sync="searchPeriod"
                      :rules="nameRules"
                      :disabled="isMassive"
                      item-value="_id"
                      item-text="name"
                      label="Periodo"
                      placeholder="Selecciona el periodo"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn depressed large @click="validate" color="primary"
                  >TOMAR LECTURA</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "DeviceTakeRead",
  components: {},
  props: ["visible", "data", "isMassive"],
  data() {
    return {
      idDevice: null,
      form: {
        period: null,
      },
      valid: true,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => v != null || "El campo es requerido"],
      datePicker1: false,
      datePicker2: false,
      dateIni: moment().subtract(30,'days').format("YYYY-MM-DD"),
      dateEnd: moment().format("YYYY-MM-DD"),
      searchPeriod: "",
      itemsPeriod: [],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.period.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    this.$root.$on("reload", async () => {
      this.searchPeriod = "";
      this.defaultDate();
      await this.getJsonPeriod();
    });
    await this.getJsonPeriod();
    this.defaultDate();
  },
  updated() {
    if(this.data._id !== this.idDevice) {
      this.idDevice = this.data._id;
      this.defaultDate();
    }
    if(this.isMassive && this.data.lastData) {
      this.form.period  = this.data.lastData.period;
      this.dateIni = this.data.lastData.dateInit.split('T')[0];
      this.dateEnd = this.data.lastData.dateNow.split('T')[0];
    }
  },
  watch: {
    searchPeriod: {
      handler() {
        if(this.isMassive === false) {
          this.getJsonPeriod().then((data) => {
            this.itemsPeriod = data.docs;
            this.form.period = this.data.lastData.period;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "listCompany",
      "updateDevice",
      "listSocialGroup",
      "listCycle",
      "listRoad",
      "listZone",
      "takeReadDevice",
      "QueryDevice",
      "alertSnackbar",
    ]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    defaultDate() {
      const cycle = this.data.cycle;
      if(cycle) {
        const today = new Date();
        let initDay = cycle.initDay;
        let endDay = cycle.endDay;
        const year = today.getFullYear();
        let endMonth = today.getMonth() + 1;
        if(endDay) {
          if(endDay > today.getDate()) {
            endMonth--;
          }
          let lastMonthDay = new Date(year, endMonth, 0);
          if(endDay > lastMonthDay.getDate()) {
            endDay = lastMonthDay.getDate();
          }
          const date = new Date(year, endMonth - 1, endDay);
          let day = date.getDate();
          let month = date.getMonth() + 1;
          day = (day < 10) ? '0' + day : day;
          month = (month < 10) ? '0' + month : month;
          this.dateEnd = date.getFullYear() + '-' + month + '-' + day;
        }
        if(initDay) {
          let initMonth = (Math.abs(initDay - endDay) > 27) ? endMonth : endMonth - 1;
          const date = new Date(year, initMonth - 1, initDay);
          let day = date.getDate();
          let month = date.getMonth() + 1;
          day = (day < 9) ? '0' + day : day;
          month = (month < 10) ? '0' + month : month;
          this.dateIni = date.getFullYear() + '-' + month + '-' + day;
        }
      } else {
        this.dateIni = moment().subtract(30,'days').format("YYYY-MM-DD");
        this.dateEnd = moment().format("YYYY-MM-DD");
      }
    },
    async getJsonPeriod() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.data.company != null ? this.data.company._id : null;

          let urlQuery = `period/list?page=1&onlyActive=true&search=${this.searchPeriod}`;
          if(idCompany != null) urlQuery += `&company=${idCompany}`;

          axios
            .get(
              urlQuery,
              { headers: headerToken }
            )
            .then((res) => {
              this.itemsPeriod = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
          });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
          period: this.form.period,
          initDate: this.dateIni,
          endDate: this.dateEnd,
        };
        let update = await this.takeReadDevice(form);
        if (update == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "Se tomo la lectura del dispositivo.",
          });
          this.$root.$emit("reload"); // parametro update tabla
          if (this.$route.name == "DeviceTakeResult") {
            this.$router.push({ name: "DeviceHome" });
          }
        }
        this.show = false;
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "getListRoad",
      "getListCycle",
      "getListCompany",
      "getListSocialGroup",
      "getListZone",
    ]),
    getTakeRead() {
      if (this.data.lastData != undefined && this.data.lastData != null) {
        return this.data.lastData;
      }
      return [];
    },
    periodSelect() {
      let filterPeriod = this.itemsPeriod
        .map((item) => {
          if (this.data.company != null) {
            if (typeof this.data.company != "object") {
              if (item.company._id === this.data.company) {
                return item;
              }
            } else {
              if (item.company._id === this.data.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterPeriod;
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.period.reset();
          this.$emit("close");
        }
      },
    },
  },
  filters: {
    formatDateFrom: (value) => {
      if (value) {
        return moment(value).locale("es").fromNow();
      }
      return "-";
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.ctn_take_read {
  display: flex;
  background-color: $color-text;
  border-radius: 4px;
  padding: 20px 10px;
  color: $light-cyan;
  .take_read_colum {
    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    align-items: center;
    .copy_read_colum {
      flex: 1 1 auto;
      justify-content: right;
      display: flex;
      flex-direction: column;
    }
  }
  h2 {
    margin-bottom: 0;
  }
  h3 {
    text-align: right;
    font-size: 1.2rem;
  }
  p {
    color: $light-cyan;
    text-align: right;
    margin-bottom: 0;
    &.day {
      margin-top: 10px;
      text-align: left;
      span.lbs {
        margin-right: 10px;
      }
    }
  }
}
</style>
